/**
 Validates org numbers from Singapore
 */
export const validateSingaporeOrgNumber = (number: string) => {
  const singaporeOrgNumberRegex =
    /^((\d{9}[A-Z])|([A-Z]\d{2}[A-Z]{2}\d{4}[A-Z]))$/g;
  return singaporeOrgNumberRegex.test(number);
};
